import { unknownToString } from "@dhau/lang-extras";
import { ApiError } from "~/api/client.ts";
import classes from "./form-errors.module.css";

type FormErrorsProps = {
	readonly errors: readonly unknown[];
};

function FormErrors({ errors }: FormErrorsProps) {
	const showErrors = errors.filter(Boolean);
	if (showErrors.length === 0) {
		return null;
	}

	console.error("form errors", showErrors);
	if (showErrors.some((e) => e instanceof ApiError)) {
		return (
			<div className={classes["form-errors"]}>
				Something went wrong! An error report has been sent to our support team.
				We’ll look into the issue as soon as possible and contact you once it’s
				resolved.
			</div>
		);
	}

	return (
		<div className={classes["form-errors"]}>
			{showErrors.map(unknownToString).join(", ")}
		</div>
	);
}

export default FormErrors;
